<script setup lang="ts">
definePageMeta({
  layout: 'character'
})

const route = useRoute()
const username = computed(() => route.params.username as string)
</script>

<template>
  <CharacterPageView :username="username" />
</template>
